import styled from 'styled-components';

const Bold = styled.span`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export default Bold;
